import { Button, Selectable } from '@hakimo-ui/shared/ui-base';
import { TrashIcon } from '@heroicons/react/24/outline';

interface ExistingSOPItemProps {
  alarmType: Selectable;
  onDelete: (alarmType: Selectable) => void;
  index: number;
}

export function ExistingSOPItem({
  alarmType,
  onDelete,
  index,
}: ExistingSOPItemProps) {
  const handleDelete = () => {
    onDelete(alarmType);
  };
  const isDefaultSOP = alarmType.id === 'default';

  return (
    <div className="text-onlight-text-2 dark:text-ondark-text-2 flex items-center justify-between">
      <span className="flex items-center gap-2">
        {index && <span className="font-medium">{index}.</span>}
        <span>{alarmType.name}</span>
      </span>
      {!isDefaultSOP && (
        <Button
          variant="icon"
          onClick={handleDelete}
          title={`Delete SOP for ${alarmType.name}`}
          className="ml-2"
        >
          <TrashIcon className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}

export default ExistingSOPItem;
